import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { Box, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 0 1rem',
  flexGrow: 1,
  overflowX: 'hidden',
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2rem',
  justifyContent: 'flex-start',
  paddingBottom: '2rem',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '1rem',
}));

export const TitleContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
}));

export const AlignButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '2rem',
}));

export const AlignMobileButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  position: 'absolute',
  right: '1rem',
  bottom: '3.2rem',
}));

export const IconColor = styled(FileDownloadOutlinedIcon)(() => ({
  color: theme.palette.primary.dark,
}));

export const ClockColor = styled(QueryBuilderIcon)(() => ({
  color: theme.palette.primary.dark,
}));
